<div class="relative w-full h-full">
    <div
        class="flex flex-col bg-white rounded-lg w-4/5 lg:w-4/12 lg:h-4/6 min-h-fit login-container"
    >
        <h1 class="flex items-center justify-center h-1/5 w-full text-3xl">
            Welcome
        </h1>
        <form
            class="flex flex-col items-center p-8 px-16 gap-8 w-full h-full"
            (submit)="onSubmitHandler($event)"
        >
            <zt-textinput
                [placeholder]="'Enter your email'"
                [control]="emailControl | formControl"
                [config]="emailFieldConfig"
            ></zt-textinput>
            <zt-textinput
                [placeholder]="'Enter your password'"
                [control]="passwordControl | formControl"
                [config]="passwordFieldConfig"
            ></zt-textinput>
            <zt-button
                [config]="loginBtnConfig"
                [type]="ZtButtonType.PRIMARY"
                [rounded]="true"
                (onClick)="loginClickHandler()"
            ></zt-button>
            <!-- <div class="text-lg text-center">
                Don't have an account?
                <a
                    [routerLink]="['/signup']"
                    class="text-teal-500 hover:underline hover:decoration-teal-500"
                    >Sign up</a
                >
            </div> -->
        </form>
    </div>
</div>
